<template>
    <div class="ufo">
        <div class="ufohead">
        </div>
        <div class="ufobody">
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.ufo{
    position: absolute;
    align-content: center;
    align-self: center;
}
.ufobody{
    display: block;
    align-self: center;
    height: 30px;
    width: 100px;
    background-color: aqua;
    border-top-right-radius: 50px;
    border-top-left-radius: 50px;
    border-bottom-right-radius: 50px;
    border-bottom-left-radius: 50px;
}
.ufohead{
    margin: auto;
    display: block;
    position: relative;
    height: 20px;
    width: 50px;
    background-color: rgba(0, 255, 255, 0.452);
    border-top-right-radius: 50px;
    border-top-left-radius: 50px;
}
</style>